import React, { useEffect, useState } from 'react'
import './Computex.css'
// import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
//
// import { useConvertSurvey } from '../hooks/useConvertSurvey'
// import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { templateJson } from './json/templateJson'
import Cookies from 'js-cookie'

const Computex = () => {
  const [littleGate, setLittleGate] = useState(false)

  const littleGateBtn = ` <div class="computex-div"><a href=${window.location.origin}/computex-2024-success><div class="computex-button">進行兌獎/Redeem Prize</div></a></div>`

  useEffect(() => {
    console.log('Cookies.get()', Cookies.get('hasReceivedAward'))
    if (Cookies.get('hasReceivedAward')) {
      if (Cookies.get('hasReceivedAward') === 'false') {
        console.log('hi')
        setLittleGate(true)
        // setSurvey(
        //   new Model()
        // )
      } else {
        setLittleGate(false)
        // setSurvey(new Model(computexJson))
      }
    }
  }, [littleGate])

  let computexJson = {
    ...templateJson,
    logo: 'https://i.postimg.cc/D05qPdfm/banner-4x.png',
    title: '【2024 COMPUTEX】BenQ SMART+ AI NOW',
    completeText: '完成',
    completedHtml: `<h3>感謝您的參與</h3>`,
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: `<div class="computex-content"><div class="computex-div"><a href=${window.location.origin}/p240430105824><div class="computex-button">中文版</div></a></div>  <div class="computex-div"><a href=${window.location.origin}/p240430105853><div class="computex-button">English Version</div></a></div></div>`,
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }

  let littleGateJson = {
    ...templateJson,
    logo: 'https://i.postimg.cc/D05qPdfm/banner-4x.png',
    title: '【2024 COMPUTEX】BenQ SMART+ AI NOW',
    completeText: '完成',
    completedHtml: `<h3>感謝您的參與</h3>`,
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: `<div class="computex-content"><div class="computex-div"><a href=${window.location.origin}/p240430105824><div class="computex-button">中文版</div></a></div>  <div class="computex-div"><a href=${window.location.origin}/p240430105853><div class="computex-button">English Version</div></a></div> <div class="computex-div"><a href=${window.location.origin}/computex-2024-success><div class="computex-button">進行兌獎/Redeem Prize</div></a></div></div>`,
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }
  // const [survey, setSurvey] = useState(new Model(computexJson))
  const survey = new Model(computexJson)
  const littleGateSurvey = new Model(littleGateJson)
  useEffect(() => {
    console.log('little', littleGate)
  }, [littleGate])

  // const survey = new Model(computexJson)
  return (
    <>
      <div className="computex-app">
        {littleGate ? (
          <Survey model={littleGateSurvey} />
        ) : (
          <Survey model={survey} />
        )}
      </div>
      {/* <div class="computex-content">
                <div class="computex-div">
                  <a href=${window.location.origin}/p240430105824>
                    <div class="computex-button">中文版</div>
                  </a>
                </div>
                <div class="computex-div">
                <a href=${window.location.origin}/p240430105824>
                  <div class="computex-button">English Version</div>
                </a>
              </div>
</div> */}

      {/* <div className="computex-app">
        <div className="content">
          <p>
            <a href={`${window.location.origin}/p240430105824`}>中文版</a>
          </p>
          <p>
            <a href="https://nezcwebdev.dsigroup.com.tw/">English Version</a>
          </p>
        </div>
      </div> */}

      {/* <p>兌獎的小門
            <a href="https://nezcwebdev.dsigroup.com.tw/">English Version</a>
          </p> */}
    </>
  )
}

export default Computex
